var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophoneSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/microphone-slash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M30.5 18.8V10C30.5 6.68629 27.8137 4 24.5 4C22.1448 4 20.1065 5.35704 19.1244 7.33187M24.5 38V44M16.5 44H32.5M6.5 6L42.5 42M10.5009 20C10.5009 20 7.50124 38 24.5801 38C29.5199 38 32.7667 36.4942 34.8865 34.3536M38.5633 26C38.973 22.6953 38.4999 20 38.4999 20M24.5 30C21.1863 30 18.5 27.3137 18.5 24V18L28.7452 28.2401C27.6592 29.3274 26.1582 30 24.5 30Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneSlash);
export default __webpack_public_path__ + "static/media/microphone-slash.23b53e692fdf13e3bda64f7a86adf88c.svg";
export { ForwardRef as ReactComponent };